class City {
  constructor(title, displayName, provinceId) {
    this.title = title;
    this.displayName = displayName;
    this.provinceId = provinceId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allCitys: [],
      city: new City('', '', null),
      allCitysForOther: [],
    };
  },
  methods: {
    getListOfCitysForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllCitys').then(() => {
        if (this.$store.state.cityModule.successFlag) {
          // this.allCitysForOther = this.$store.state.cityModule.allCitys;
          this.allCitysForOther = Array.isArray(this.$store.state.cityModule.allCitys)
            ? this.$store.state.cityModule.allCitys
            : [];

          if (this.$route.name == 'user') {
            this.allUserCitys = this.allCitysForOther;
            this.readyUserCity();
          }
          if (this.formLoad) {
            if (this.allCitysForOther.length === 1) {
              this.selectedCity = this.allCitysForOther[0];
              this.searchForLocation(
                this.allCitysForOther[0].title,
                this.allCitysForOther[0].province.title,
              );
            }
          }
          if (this.deploymentFormLoad) {
            if (this.allCitysForOther.length === 1) {
              this.deploymentSelectedCity = this.allCitysForOther[0];
              this.searchForLocation(
                this.allCitysForOther[0].title,
                this.allCitysForOther[0].province.title,
              );
            }
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.cityModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfCitysForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.cityModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfCitysForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllCitys: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllCitys').then(() => {
        if (this.$store.state.cityModule.successFlag) {
          // let temp = this.$store.state.cityModule.allCitys;

          let temp = Array.isArray(this.$store.state.cityModule.allCitys)
            ? this.$store.state.cityModule.allCitys
            : [];

          this.allCitys = [];
          for (let i = 0; i < temp.length; i++) {
            this.allCitys.push({
              title: temp[i].title ? temp[i].title : '-',
              displayName: temp[i].displayName ? temp[i].displayName : '-',
              province: temp[i].province ? temp[i].province.title : '-',
              counter: i + 1,
              id: temp[i].id,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.cityModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllCitys();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.cityModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllCitys();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addCityFunction: function () {
      if (!this.city.provinceId) {
        this.snackText = 'استان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.city.title) {
        this.snackText = 'عنوان شهرستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.city.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان شهرستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addCity', this.city).then(() => {
        if (this.$store.state.cityModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' شهرستان با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.city = new City('', '', null);
          this.getAllCitys();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.cityModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addCityFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.cityModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addCityFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getCityFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getCity', id).then(() => {
        if (this.$store.state.cityModule.successFlag) {
          let temp = this.$store.state.cityModule.city;
          this.city.id = temp.id;
          this.city.title = temp.title;
          this.city.displayName = temp.displayName;
          this.city.provinceId = temp.province.id;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.cityModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getCityFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.cityModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getCityFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editCityFunction: function () {
      if (!this.city.provinceId) {
        this.snackText = 'استان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.city.title) {
        this.snackText = 'عنوان شهرستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.city.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان شهرستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editCity', this.city).then(() => {
        if (this.$store.state.cityModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllCitys();
          this.snackText = ' شهرستان با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.city = new City('', '', null);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.cityModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editCityFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.cityModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editCityFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteCityFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteCity', this.cityId).then(() => {
        if (this.$store.state.cityModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllCitys();
          this.snackText = ' شهرستان با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.cityModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteCityFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.cityModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteCityFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.cityModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
